import React from "react";

interface Props {
  label: string;
  selected: boolean;
  onClick: (e: string) => void;
}

const SearchBadge = ({ label, selected, onClick }: Props) => {
  return (
    <span
      onClick={() => {
        onClick(label);
      }}
      className={`whitespace-nowrap inline-flex items-center transition-all rounded-full hover:ring-2 cursor-pointer ${
        selected && "bg-primary-100"
      } ring-1 ring-primary-700 px-3 py-0.5 text-sm font-medium text-primary-700
        `}
    >
      {label}
    </span>
  );
};

export default SearchBadge;
